var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          attrs: { novalidate: "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit()
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200px",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              link: "page-categories",
                              title: _vm.data.title
                                ? `${_vm.data.title} категория`
                                : `Создать категорию`,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "span",
                                        [
                                          _vm._v("Заголовок * ("),
                                          _c("TranslationIcon"),
                                          _vm._v(")"),
                                        ],
                                        1
                                      ),
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          autofocus: "",
                                          id: "title",
                                          "error-messages":
                                            _vm.validationErrors.title,
                                          disabled: _vm.loading,
                                          loading: _vm.loading,
                                        },
                                        model: {
                                          value: _vm.fields.title,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.fields, "title", $$v)
                                          },
                                          expression: "fields.title",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          label: "Сортировка",
                                          disabled: _vm.loading,
                                          loading: _vm.loading,
                                          "error-messages":
                                            _vm.validationErrors.sortOrder,
                                        },
                                        model: {
                                          value: _vm.fields.sortOrder,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.fields,
                                              "sortOrder",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "fields.sortOrder",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              !_vm.isNew
                                ? _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              id: "slug",
                                              label: "Имя *",
                                              disabled: _vm.loading,
                                              loading: _vm.loading,
                                              "error-messages":
                                                _vm.validationErrors.slug,
                                            },
                                            on: {
                                              input: _vm.$v.fields.slug.$touch,
                                            },
                                            model: {
                                              value: _vm.fields.slug,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "slug",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "fields.slug",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c("MediaFilePicker", {
                                        attrs: {
                                          label: "Изображение",
                                          multiple: false,
                                          "file-type":
                                            _vm.$options.mediaTypesByKeys.IMAGE,
                                          value: _vm.fields.imageId,
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.fields.imageId = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c("SeoSettings", {
                                        attrs: {
                                          data: _vm.data,
                                          loading: _vm.loading,
                                        },
                                        on: {
                                          "on-input-seo": function ($event) {
                                            _vm.fields = Object.assign(
                                              {},
                                              _vm.fields,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("ManageSidePanel", {
                    attrs: {
                      "is-new": !_vm.data.id,
                      "created-at": _vm.data.createdAt,
                      "updated-at": _vm.data.updatedAt,
                      "d-at": "data.publishedAt",
                      author: _vm.data.author,
                      "is-loading":
                        _vm.loading ||
                        _vm.$apollo.queries.eventAttributeKeys.loading,
                      language: _vm.language,
                      translations: _vm.fields.translations,
                      "entity-id": _vm.data.id,
                      "entity-type": "eventCategory",
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.$emit("delete-category")
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-categories" })
                      },
                      "update-translations": function ($event) {
                        return Object.assign(_vm.fields.translations, $event)
                      },
                      "language-update": function ($event) {
                        return _vm.$emit("language-update", $event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "body",
                        fn: function () {
                          return [
                            !!_vm.eventAttributeKeys
                              ? _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-card-subtitle",
                                      { staticClass: "text-h6 mb-2" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "page-new-event-category.form.attrList"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-chip-group",
                                      {
                                        attrs: {
                                          value:
                                            _vm.fields.attributeKeys.map(
                                              (attr) =>
                                                _vm.eventAttributeKeys.findIndex(
                                                  (i) => i.name === attr.name
                                                )
                                            ) || [],
                                          column: "",
                                          multiple: "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.fields.attributeKeys =
                                              $event.map((i) => ({
                                                name: _vm.eventAttributeKeys[i]
                                                  .name,
                                              })) || []
                                          },
                                        },
                                      },
                                      _vm._l(
                                        _vm.eventAttributeKeys,
                                        function (attributeKeys) {
                                          return _c(
                                            "v-chip",
                                            {
                                              key: attributeKeys.name,
                                              attrs: {
                                                filter: "",
                                                outlined: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    attributeKeys.displayName
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }